export const ModelRFQ3 = () => {
  return {
    id: null,
    rfqid: null,
    chosen: false,
    qty: 1,
    partID: null,
    partSN: '',
    price: '',
    currencyID: null,
    conditionID: null,
    releaseID: null,
    traceabilityCompanyID: null,
    tagInfoCompanyID: null,
    tagDate: null,
    supplyDate: '',
    stockID: null,
    exchangeCoreValue: null,
    exchangeCoreValueCurrencyID: null,
    exchangeConditionID: null,
    coreDueDate: null,
    exchangeCoreReceived: false,
    sendMail: false,
    quoteDate: null,
    remarks: ''
  }
}
